<template>
  <div style="padding-bottom: 40px">
    <div style="padding: 5px 5px 0 0;margin:0 5px;">
      <!--试产信息 -->
      <el-form :model="prcItem" label-width="130px" size="small" disabled>
        <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>试产信息:</b></el-row>
        <el-form-item label="项目/产品名称:">
          <el-input v-model="prcItem.pro_name"/>
        </el-form-item>
        <el-row>
          <el-form-item label="材料名称:" style="width: 50%">
            <el-input v-model="prcItem.material_name"/>
          </el-form-item>
          <el-form-item label="材料颜色:" style="width: 50%">
            <el-input v-model="prcItem.material_color"/>
          </el-form-item>
        </el-row>
        <el-form-item label="牌号:">
          <el-input v-model="prcItem.shop_no"/>
        </el-form-item>
        <el-form-item label="批号:">
          <el-input v-model="prcItem.batch_no"/>
        </el-form-item>
        <el-row>
          <el-form-item label="模具编号:" style="width: 50%">
            <el-input v-model="prcItem.mold_id"/>
          </el-form-item>
          <el-form-item label="试产机台编号:" style="width: 50%">
            <el-input v-model="prcItem.machine_no"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="模具穴数:" style="width: 50%">
            <el-input v-model="prcItem.cavity"/>
          </el-form-item>
          <el-form-item label="作业员需求(人*h):" style="width: 50%">
            <el-input v-model="prcItem.operator_need_user" style="width: 49%;"/>
            *
            <el-input v-model="prcItem.operator_need_time" style="width: 48%;"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="成型周期:" style="width: 50%">
            <el-input v-model="prcItem.molding_cycle"/>
          </el-form-item>
          <el-form-item label="预计完成时间:" style="width: 50%">
            <el-date-picker v-model="prcItem.finish_date" style="width: 100%"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="材料需求用量(kg):" style="width: 50%">
            <el-input v-model="prcItem.material_need"/>
          </el-form-item>
          <el-form-item label="计划产出数(pcs):" style="width: 50%">
            <el-input v-model="prcItem.pcs"/>
          </el-form-item>
        </el-row>
        <el-form-item label="需求日期:" style="width: 50%">
          <el-date-picker v-model="prcItem.need_date" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="申请目的:">
          <el-input v-model="prcItem.put_in_purpose"/>
        </el-form-item>
        <el-form-item label="流程:">
          <el-input type="textarea" autosize v-model="prcItem.process_content"/>
        </el-form-item>
      </el-form>

      <!--需求内容 -->
      <div style="margin: 20px 0 0 10px">
        <el-form :model="prcItem" size="small" disabled >
          <el-row style="text-align: center;">

            <!--表头-->
            <el-col :span="4">
              <el-col style="font-size: 19px;font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">部门</el-col>
              <el-col class="el_col1">PMC</el-col>
              <el-col style="margin: 5px 0 0 0">
                <el-row>
                  <el-col :span="6" style="border:groove 1px #e0dddd;background-color: #F5F7FA;writing-mode: vertical-lr;">工程部</el-col>
                  <el-col :span="18">
                    <el-col class="el_col3">注塑</el-col>
                    <el-col class="el_col1" style="background-color: #F5F7FA;">硬化</el-col>
                    <el-col class="el_col1">镀膜</el-col>
                    <el-col class="el_col1" style="background-color: #F5F7FA;">精雕&组装</el-col>
                  </el-col>
                </el-row>
              </el-col>
              <el-col class="el_col1" style="background-color: #F5F7FA;">品质部</el-col>
              <el-col class="el_col1">模具</el-col>
              <el-col class="el_col1" style="background-color: #F5F7FA;">生产部</el-col>
            </el-col>

            <!--内容-->
            <el-col :span="20">
              <el-col style="font-size: 19px;font-weight:bold;background-color: #F5F7FA;">
                <el-row>
                  <el-col :span="4" style="border:groove 1px #e0dddd;">有无需求</el-col>
                  <el-col :span="20" style="border:groove 1px #e0dddd;">需求内容</el-col>
                </el-row>
              </el-col>

              <!--PMC -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.pmc_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.pmc_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--注塑 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.im_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.im_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--硬化 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.harden_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.harden_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--镀膜 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.cf_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.cf_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--精雕&组装 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.carving_assemble_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.carving_assemble_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--品质部 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.quality_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.quality_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--模具 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.mold_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.mold_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <!--生产部 -->
              <el-col style="margin: 5px 0 0 0;">
                <el-row>
                  <el-col :span="4" class="el_col3">
                    <el-checkbox v-model="prcItem.production_need"></el-checkbox>
                  </el-col>
                  <el-col :span="20" class="el_col3">
                    <el-input v-model="prcItem.production_need_content"></el-input>
                  </el-col>
                </el-row>
              </el-col>

            </el-col>
          </el-row>
        </el-form>
      </div>

      <!--项目经理审批-->
      <div style="margin: 20px 0 0 10px">
        <el-form :model="prcItem" size="small" disabled label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>项目主管核准:</b></el-row>
          <el-row>
            <el-form-item label="核准结果:" style="width: 50%;">
              <el-select v-model="prcItem.department_check1_result" clearable filterable>
                <el-option v-for="item in departmentCheck1Result" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;">
              <el-input v-model="prcItem.department_check1_user_full_name" clearable filterable/>
            </el-form-item>
          </el-row>
          <el-form-item label="备注:">
            <el-input v-model="prcItem.department_check1_remark" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <!--PMC计划安排-->
      <div style="margin: 20px 0 0 10px" >
        <el-form :model="prcItem" size="small" disabled label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>PMC计划安排:</b></el-row>
          <el-row>
            <el-form-item label="试产时间:" style="width: 50%;">
              <el-date-picker v-model="prcItem.plan_date" type="datetimerange" clearable filterable/>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;">
              <el-input v-model="prcItem.pmc_plan_user_full_name" clearable filterable/>
            </el-form-item>
          </el-row>
          <el-form-item label="备注:">
            <el-input v-model="prcItem.pmc_plan_remark" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <!--工程部注塑意见/签字-->
      <div style="margin: 20px 0 0 10px" v-if="isShow1">
        <el-form :model="prcItem" size="small" :disabled="disabled1" label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>工程部注塑意见/签字:</b></el-row>
          <el-form-item label="开始时间~结束时间:" required>
            <el-date-picker v-model="prcItem.im_date" type="datetimerange" :editable="false"/>
          </el-form-item>
          <el-row>
            <el-form-item label="意见结果:" style="width: 50%;" required>
              <el-select v-model="prcItem.im_engineering_sign_result"  clearable>
                <el-option v-for="item in agreeResultFalseList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;" required>
              <el-input v-model="prcItem.im_engineering_sign_user_full_name" disabled />
            </el-form-item>
          </el-row>
          <el-form-item label="意见描述:">
            <el-input v-model="prcItem.im_engineering_sign_describe" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <!--工程部硬化意见/签字-->
      <div style="margin: 20px 0 0 10px" v-if="isShow2">
        <el-form :model="prcItem" size="small" :disabled="disabled2" label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>工程部硬化意见/签字:</b></el-row>
          <el-form-item label="开始时间~结束时间:">
            <el-date-picker v-model="prcItem.harden_date" type="datetimerange" :editable="false"/>
          </el-form-item>
          <el-row>
            <el-form-item label="意见结果:" style="width: 50%;">
              <el-select v-model="prcItem.harden_engineering_sign_result" clearable >
                <el-option v-for="item in agreeResultFalseList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;">
              <el-input v-model="prcItem.harden_engineering_sign_user_full_name" clearable disabled />
            </el-form-item>
          </el-row>
          <el-form-item label="意见描述:">
            <el-input v-model="prcItem.harden_engineering_sign_describe" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <!--工程部镀膜意见/签字-->
      <div style="margin: 20px 0 0 10px" v-if="isShow3">
        <el-form :model="prcItem" size="small" :disabled="disabled3" label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>工程部镀膜意见/签字:</b></el-row>
          <el-form-item label="开始时间~结束时间:" required>
            <el-date-picker v-model="prcItem.cf_date" type="datetimerange" :editable="false"/>
          </el-form-item>
          <el-row>
            <el-form-item label="意见结果:" style="width: 50%;" required>
              <el-select v-model="prcItem.cf_engineering_sign_result" clearable >
                <el-option v-for="item in agreeResultFalseList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;" required>
              <el-input v-model="prcItem.cf_engineering_sign_user_full_name" clearable disabled />
            </el-form-item>
          </el-row>
          <el-form-item label="意见描述:">
            <el-input v-model="prcItem.cf_engineering_sign_describe" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <!--工程部精雕&组装意见/签字-->
      <div style="margin: 20px 0 0 10px" v-if="isShow4">
        <el-form :model="prcItem" size="small" label-width="130px">
          <el-row style="margin-bottom: 10px;margin-left: 13px;"><b>工程部精雕&组装意见/签字:</b></el-row>
          <el-form-item label="开始时间~结束时间:" required>
            <el-date-picker v-model="prcItem.carving_date" type="datetimerange" :editable="false"/>
          </el-form-item>
          <el-row>
            <el-form-item label="意见结果:" style="width: 50%;" required>
              <el-select v-model="prcItem.carving_engineering_sign_result" clearable >
                <el-option v-for="item in agreeResultFalseList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="核准人:" style="width: 50%;" required>
              <el-input v-model="prcItem.carving_engineering_sign_user_full_name" clearable disabled />
            </el-form-item>
          </el-row>
          <el-form-item label="意见描述:">
            <el-input v-model="prcItem.carving_engineering_sign_describe" type="textarea" autosize clearable filterable/>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="primary" @click="submit" style="margin-left: 10px;width: 99%;">提交</el-button>
    </div>
  </div>

</template>

<script>
import {ArrowLeft} from "@element-plus/icons-vue";

export default {
  name: "PrcMobileApp2",
  props: {
    prcItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  components: {ArrowLeft},
  data() {
    return {
      disabled1:false,
      disabled2:false,
      disabled3:false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.core.currentUser;
    },
    departmentCheck1Result(){
      return this.$store.getters['core/getDictList']('dfm_review_result');
    },
    agreeResultFalseList() {
      return this.$store.getters['core/getDictList']('agree_result_false');
    },
  },
  async created() {
    this.judgeStatus();
  },
  mounted() {
  },
  methods: {

    judgeStatus(){

      //判断页面是否显示和页面只读数据
      if (this.prcItem.im_need === true) {
        this.isShow1 = true;
        if (this.prcItem.im_engineering_sign_result) {
          this.disabled1 = true;
        } else {
          this.prcItem.im_engineering_sign_user_full_name = this.user.full_name
          return
        }
      }

      if (this.prcItem.harden_need === true){
        this.isShow2 = true;
        if (this.prcItem.harden_engineering_sign_result){
          this.disabled2 = true;
        }else {
          this.prcItem.harden_engineering_sign_user_full_name = this.user.full_name
          return;
        }
      }

      if (this.prcItem.cf_need  === true){
        this.isShow3 = true;
        if (this.prcItem.cf_engineering_sign_result){
          this.disabled3 = true;
        }else {
          this.prcItem.cf_engineering_sign_user_full_name = this.user.full_name
        }
      }

      if (this.prcItem.carving_assemble_need === true){
        this.isShow4 = true;
        this.prcItem.carving_engineering_sign_user_full_name = this.user.full_name
      }
    },

    async submit() {

      //注塑
      if (this.isShow1 && !this.disabled1){
        if (!this.prcItem.im_date){
          return this.$message.error('请选择注塑开始时间~结束时间');
        }
        if (!this.prcItem.im_engineering_sign_result){
          return this.$message.error('请选择注塑意见结果');
        }

        this.prcItem.nextNodeId = "im_engineering_sign";
      }
      //硬化
      if (this.isShow2 && !this.disabled2){
        if (!this.prcItem.harden_date){
          return this.$message.error('请选择硬化开始时间~结束时间');
        }
        if (!this.prcItem.harden_engineering_sign_result){
          return this.$message.error('请选择硬化意见结果');
        }
        this.prcItem.nextNodeId = "harden_engineering_sign";
      }
      //镀膜
      if (this.isShow3 && !this.disabled3){
        if (!this.prcItem.cf_date){
          return this.$message.error('请选择镀膜开始时间~结束时间');
        }
        if (!this.prcItem.cf_engineering_sign_result){
          return this.$message.error('请选择镀膜意见结果');
        }

        this.prcItem.nextNodeId = "cf_engineering_sign";
      }
      //精雕&组装
      if (this.isShow4){
        if (!this.prcItem.carving_date){
          return this.$message.error('请选择精雕&组装开始时间~结束时间');
        }
        if (!this.prcItem.carving_engineering_sign_result){
          return this.$message.error('请选择精雕&组装意见结果');
        }

        this.prcItem.nextNodeId = "carving_engineering_sign";
      }

      await this.$http('prcMobileAppService.submit', this.prcItem)

      this.$emit("goBack")
      return this.$message.success("提交成功")
    }

  }
};
</script>

<style lang="less" scoped>

:deep(.el-form-item) {
  margin-bottom: 8px;
}

.el_col1 {
  border: groove 1px #e0dddd;
  margin: 5px 0 0 0;
  height: 26px
}

.el_col3 {
  border: groove 1px #e0dddd;
  height: 26px
}

.el_col3 {
  border: groove 1px #e0dddd;
  height: 26px
}




</style>

